import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { AddUserType } from "types/UsersTypes";
import { queryClient } from "App";

export const useCreateAccountAsAdmin = (
  options?: UseMutationOptions<any, Error, AddUserType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["addUser"],
    mutationFn: async ({ name, phonePrefixUuid, phoneNumber, email, rodoPreference, file }) => {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("phonePrefixUuid", phonePrefixUuid);
      formData.append("phoneNumber", phoneNumber);

        if (rodoPreference) {
          formData.append("rodoPreference", rodoPreference);
        }

        if (email) {
          formData.append("email", email);
        }

        if (file) {
          formData.append("file", file);
        }

      return axiosInstance
        .post("/users/as/admin", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa dodawanie konta...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "add-user",
      });
      if (options && options.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Pomyślnie dodano konto.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "add-user",
      });
      queryClient.prefetchQuery({ queryKey: ["users"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      
      if (error.data.message === "Phone number exist") {
        Toast({
          message: "Podany numer telefonu jest już zarejestrowany.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "add-user",
        });
      } else if (error?.data?.errors[0]?.rule === 'file.size') {
        Toast({
          message: "Plik jest zbyt duży, maksymalny rozmiar to 20MB.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "add-user",
        });
      } else {
        Toast({
          message: "Błąd podczas dodawania konta.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "add-user",
        });
      }
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useCreateAccountAsAdmin;
